// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_chy","cls2":"Header-cls2_b0T Header-cls1_chy"};